import { useState } from 'react';
import { MessageCircle, Sparkles } from 'lucide-react';
import { ComingSoonCallout } from './ComingSoonCallout';

export function CommunityCta() {
  const [show, setShow] = useState(false);
  return (
    <div className="flex flex-col gap-3 rounded-[20px] border border-[#ececec] bg-white p-5 shadow-[0px_1px_1.5px_rgba(0,0,0,0.1),0px_1px_1px_rgba(0,0,0,0.1)] sm:px-[33px] sm:py-5">
      <div className="flex flex-col gap-3 sm:h-[60px] sm:flex-row sm:items-center sm:justify-between sm:py-0">
        <div className="flex items-center gap-4">
          <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-[#f5f3ff]">
            <MessageCircle className="size-[18px] text-[#8b5cf6]" />
          </span>
          <div>
            <p className="text-sm font-bold text-[#111827]">Have a question?</p>
            <p className="text-xs leading-4 text-[#9ca3af]">Ask your batch or get help from faculty.</p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          aria-expanded={show}
          className="flex h-10 shrink-0 items-center gap-1.5 rounded-[14px] border border-[#8b5cf6] px-[21px] text-sm font-semibold text-[#8b5cf6] hover:bg-[#f5f3ff]"
        >
          <Sparkles className="size-3.5" />
          Coming Soon
        </button>
      </div>
      <ComingSoonCallout show={show} onDismiss={() => setShow(false)} />
    </div>
  );
}
